import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";

export default function useGetTabs() {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  function getSecurityLevelTabs() {
    const innerTabs = [
      {
        id: selectedLanguage.LstLanguageCodes.UI_TrackViews,
        label: selectedLanguage.LstLanguageCodes.UI_TrackViews,
        icontext: `visibility_lock`,
        className: "material-symbols-outlined font-24",
      },
      {
        id: selectedLanguage.LstLanguageCodes.UI_TrackReaders,
        label: selectedLanguage.LstLanguageCodes.UI_TrackReaders,
        icontext: "manage_accounts",
        className: "material-icons font-24",
      },
      {
        id: selectedLanguage.LstLanguageCodes.UI_LimitReaders,
        label: selectedLanguage.LstLanguageCodes.UI_LimitReaders,
        icontext: "lock_person",
        className: "material-icons font-24",
      },
    ];

    return { innerTabs };
  }

  function getContentSecurityTabs() {
    const innerTabs = [
      {
        id: selectedLanguage.LstLanguageCodes.UI_CipherTextTab,
        label: selectedLanguage.LstLanguageCodes.UI_CipherTextTab,
        icontext: "display_settings",
        className: "material-icons font-24",
      },
      {
        id: selectedLanguage.LstLanguageCodes.UI_FloatingTextTab,
        label: selectedLanguage.LstLanguageCodes.UI_FloatingTextTab,
        icontext: "wysiwyg",
        className: "material-icons font-24",
      },
    ];

    return { innerTabs };
  }

  return { getSecurityLevelTabs, getContentSecurityTabs };
}
